<template>
    <div>
        <hos_apply_title title="患者基本信息"></hos_apply_title>
        <el-form :model="detail" class="mt10" label-position="left" size="mini">
            <!--<el-row>-->
            <!--<el-col :span="24">-->
            <!--<el-form-item label="患者就诊卡号:" label-width="100px">-->
            <!--{{detail.cardId}}-->
            <!--</el-form-item>-->
            <!--</el-col>-->
            <!--</el-row>-->
            <el-row>
                <el-col :span="8">
                    <el-form-item label="病人姓名:" label-width="80px" class="marginBottom">
                        {{detail.patName}}
                    </el-form-item>
                </el-col>
                <el-col :span="14" :push="2">
                    <el-form-item label="证件号:" label-width="80px" class="marginBottom">
                        {{detail.patIdcard}}
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="5">
                    <el-form-item label="性别:" label-width="50px" class="marginBottom">
                        {{detail.patGender | formateSex}}
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <el-form-item label="年龄:" label-width="50px" class="marginBottom">
                        {{detail.patAge}}
                    </el-form-item>
                </el-col>
                <el-col :span="14">
                    <el-form-item label="电话:" label-width="50px" class="marginBottom">
                        {{detail.patMobile}}
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="10">
                    <el-form-item label="职业:" label-width="50px" class="marginBottom">
                        {{detail.patJob || '无'}}
                    </el-form-item>
                </el-col>
                <el-col :span="14">
                    <el-form-item label="其他联系方式:" label-width="100px" class="marginBottom">
                        {{detail.otherContactWay || '无'}}
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="家庭地址:" label-width="80px" class="marginBottom">
                        {{detail.areaName}} {{detail.address}}
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
    import hos_apply_title from "../../components/hos/hos-apply-title"
    export default {
        name: "base-form_detail",
        components:{hos_apply_title},
        props:{
            detail:{
                type:Object
            }
        },
        filters:{
            formateSex(val){
                return val == 'F' ? '女' : '男'
            }
        },
        data(){
            return {

            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/hos";
</style>